<template>
  <div>
    <v-card flat class="mt-5">
      <h5>Kortbeställningar</h5>
      <v-data-table
        :headers="[
          {text: 'TYP AV KORT', sortable: false, filterable: false, value: 'displayType', width: '340'},
          {text: 'BESTÄLLT', sortable: false, filterable: false, value: 'createdAt', width: '120'},
          {text: 'BESTÄLLT AV', filterable: false, value: 'createdBy', width: '170'},
          {text: 'STATUS', sortable: false, filterable: false, value: 'printOrderState', width: '160'},
          {text: '', filterable: false, value: 'actions'}
        ]"
        :items="printOrders"
        :loading="isLoading"
        :items-per-page="itemsPerPage"
        hide-default-footer
        item-key="id"
      >
        <template slot="item.createdAt" slot-scope="props">
          {{ props.item.createdAt | date }}
        </template>
        <template slot="item.createdBy" slot-scope="props">{{ props.item.issuedOn | date }}</template>
        <template slot="item.createdBy" slot-scope="props">
          <div v-if="props && props.item && props.item.createdBy">
            {{ props.item.createdBy.firstName ? props.item.createdBy.firstName : '' }}
            {{ props.item.createdBy.lastName ? props.item.createdBy.lastName : '' }}
          </div>
        </template>

        <template slot="item.printOrderState" slot-scope="props">
          <div>
            {{ props.item.printOrderState.name }}
          </div>
        </template>

        <template slot="item.actions" slot-scope="props">
          <span :data-cy-id="props.item.id"></span>
          <div class="d-flex justify-end">
            <v-btn
              class="ml-4"
              data-cy="delete-card"
              color="secondary"
              @click="
                mcMode = 'edit'
                printCardId = props.item.id
                mcModal = true
              "
            >
              Visa / Ändra
            </v-btn>
          </div>
        </template>
      </v-data-table>

      <v-dialog v-model="mcModal" :max-width="'720px'">
        <CreateShowCard
          @showCreateCardInfo="showCreateCardInfo"
          :printCardId="printCardId"
          :printOrders="printOrders" 
          :education="education"
          @deleted="
            mcMode = 'create'
            mcModal = false
            deleted()
          "
          @close="
            mcMode = 'create'
            mcModal = false
            fetchPerson()
          "
          :mode="mcMode"
        />
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import API from '@/services/api'
import get from 'lodash/get'
import {UserRules} from '@/components/mixins'
import CreateShowCard from '@/components/person/MachineCard/CreateShowCard'
import {pageSize} from '@/store/constants'
//import { Object } from 'sugar'
// @group Person
// PersonMachinaCard component
export default {
  name: 'PersonMachinCard',
  mixins: [UserRules],
  props: {
    refresh: Boolean,
    education: {
      type: Object,
      // Object or array defaults must be returned from
      // default empty
      default: function () {
        return {}
      }
    },
    initialMode: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    mcModal: false,
    mcMode: '',
    printCardId: 0,
    cardCreatedFor: {},
    mcModalObj: {},    
    printOrders: [],
    itemsPerPage: pageSize
  }),
  components: {
    CreateShowCard
  },
  watch: {
    initialMode(newValue) {
      if (newValue === 'Beställ maskinkort') {
        this.mcMode = 'create'
        this.mcModal = true
      }
    },
    refresh() {
      this.fetchPerson()
    }
  },
  created() {
    this.fetchPerson()
  },
  computed: {
    ...mapGetters('person', ['selectedPerson']),
    ...mapGetters('app', ['isLoading'])
  },
  methods: {
    ...mapActions('person', ['setSelectedPerson']),
    /**
     * @vuese
     * Used to fetch person
     * @arg The argument is integer values representing person id
     */
    fetchPerson() {
      this.mcMode = 'create'
      this.printOrders = []
      //this.education=this.selectedPerson.educations.find(f=>f.basicEducationCertificate!=null)
      API.getPersonPrintOrders(this.selectedPerson.id)
        .then(res => { 
          res.data.forEach(p => {
            let type = ''
            let machines = ''
            if (p.displayType === 'Maskinintyg') {
              let machineCertificateMachines = get(p, 'print.machineCertificateMachines', [])
              machines = machineCertificateMachines.map(m => m.machine.name).join(', ')
              type = 'Maskinkort: '
            } else {
              type = p.displayType
            }
            this.printOrders.push({
              id: p.id,
              printOrderState: p.printOrderState,
              createdBy: p.createdBy,
              createdAt: p.createdAt,
              displayType: type + machines
            })
          })
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    deleted(val) {
      this.printCardId = 0
      this.printOrders.splice(val, 1)
    },
    showCreateCardInfo() {
      this.mcModal = false
      this.fetchPerson()
    }
  }
}
</script>

<style>
</style>
